import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import TicketsButton from '../components/TicketsButton';
import { setShowCalendarInModal } from '../actions/ui';
import { ticketPickerOpened, setCheckoutOverlay } from 'checkout/actions/ui';
import { triggerTransition } from '@uirouter/redux';
import { reservationActive } from '@/selectors/reservation';
import { setEventTimes, setSelectedDate, setSelectedChildEvent, setSelectedEventTimeObject, selectChildEventAndContinue } from '../views/series/actions/event-series';
import { isValidDateObject } from '../../helpers/time';
import { removeListingItem } from '../../listing/helpers/storage';
import { getSeriesOption } from '../views/series/selectors/eventSeries';
import { isKioskMode } from '../selectors/ui';
import { fetchEvent } from '../actions/event';

class TicketsButtonContainer extends Component {
    state = {
        loading: false,
    };

    render() {
        if(this.props.listingSoldOut === true) {
            if (this.props.uiConfig.listings.useCustomSoldOutText && typeof this.props.uiConfig.listings.soldOutText !== "undefined" && this.props.uiConfig.listings.soldOutText !== "") {
                return <span>{this.props.uiConfig.listings.soldOutText}</span>;
            }

            return this.props.isKioskMode ? <span>This event is sold out.</span> : <span>SOLD OUT</span>;
        }

        return(
            <TicketsButton
                uiConfig={this.props.uiConfig}
                priceLevels={this.props.priceLevels}
                onClick={this.startCheckout}
                coupon={this.props.coupon}
                hasPresale={this.props.hasPresale}
                isOnsale={this.props.isOnsale}
                title={this.props.title}
                type={this.props.type}
                loading={this.state.loading}
                isRecurring={this.props.isRecurring}
            >
                {this.props.children}
            </TicketsButton>
        )
    }

    startCheckout = () => {
        //in kiosk mode, refresh local data before transitioning to the next step
        if (this.props.isKioskMode) {
            this.setState({loading: true});
            this.props.fetchEvent().finally(() => {
                this.setState({loading: false});
                //if option to open to nearest available event time enabled for kiosk,
                //  1. open to nearest time if the next time is not sold out
                //  2. if the next time is sold out open to the kiosk time picker
                //  3. if the day is sold out, open to series date picker
                //
                //Note: this code should likely be revisted when inventory service is up and running.
                if (this.props.isRecurring && this.props.openToNextAvailable){
                    let hasOnsaleEventToday = false;
                    if (this.props.eventsToday && this.props.eventsToday.length) {

                        this.props.eventsToday.map(eventTime => {
                            if (eventTime.eventStatus === 'on_sale') {
                                hasOnsaleEventToday = true;
                            }
                        });

                        if (!hasOnsaleEventToday) {
                            this._startCheckout();
                        } else {
                            const now = new Date();

                            //sort by time ascending
                            const todaysEvents = this.props.eventsToday.sort((a,b) => {
                                const aDate = new Date(a.time);
                                const bDate = new Date(b.time);
                                if (!isValidDateObject(aDate) || !isValidDateObject(bDate)) {
                                    return 1;
                                }
                                return aDate.getTime() - bDate.getTime();
                            });

                            for (let i = 0; i < todaysEvents.length; i++) {

                                let event = todaysEvents[i];
                                let eventTime = new Date(event.time);

                                if (isValidDateObject(eventTime) && eventTime.getTime() > now.getTime()) {

                                    //if closest event is not on sale, open time picker
                                    if (event.eventStatus !== 'on_sale') {
                                        this.props.setSelectedDate(now).then(() => {
                                            this.props.triggerTransition('kioskTimePicker');
                                        });
                                    } else {
                                        //clear previously populated data
                                        this.props.setEventTimes([]);
                                        removeListingItem(this.props.listingSlug, 'selectedEventId');

                                        this.props.setSelectedDate(eventTime).then(() => {
                                            this.selectEvent(event);
                                        });
                                    }

                                    break;
                                }
                            }
                        }
                    } else {
                        this._startCheckout();
                    }
                } else {
                    this._startCheckout();
                }
            });
        } else {
            this._startCheckout();
        }
    }

    _startCheckout = () => {
        if (!this.props.reservationActive && this.props.isRecurring) {
            //setting checkout overlay handled in transition for seriesDatePicker
            this.props.triggerTransition('seriesDatePicker');
        } else if ((!this.props.isOnsale && this.props.hasPresale && Object.keys(this.props.priceLevels.levels).length === 0 && this.props.coupon.isPresaleCodeApplied === false) || (this.props.hasPlAccess === true && Object.keys(this.props.priceLevels.levels).length === 0)) {
            // presale or no PLs available w/o access code
            this.props.setCheckoutOverlay(true);
            this.props.triggerTransition('coupon');
        } else {
            this.props.setCheckoutOverlay(true);
            this.props.ticketPickerOpened();
            if(typeof this.props.showCheckoutCallback === "function") {
                this.props.showCheckoutCallback();
            }
        }
    }

    selectEvent = (event) => {
        this.props.setSelectedEventTimeObject(event);
        this.props.setSelectedChildEvent(event.id);
        this.props.selectChildEventAndContinue(event.id);
    }
}

const mapStateToProps = state => {
    const theEvent = Object.values(state.event.events)[0].event;
    return {
        listingSlug: state.ui.listingSlug,
        uiConfig: state.ui.uiConfig,
        priceLevels: state.priceLevel,
        coupon: state.coupon,
        hasPresale: theEvent.hasPresale,
        isOnsale: theEvent.isOnsale,
        hasPlAccess: theEvent.hasPlAccess,
        isRecurring: theEvent.isRecurring,
        eventDates: theEvent.eventDates,
        reservationActive: reservationActive(state),
        listingSoldOut: state.ui.listingSoldOut,
        eventId: theEvent.event_id,
        apiUrl: state.ui.apiUrl,
        openToNextAvailable: getSeriesOption("openToNextAvailable", false)(state) ? true : false,
        isKioskMode: isKioskMode(state),
        eventsToday: state.eventSeries.eventsToday,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        ticketPickerOpened,
        triggerTransition,
        setEventTimes,
        setSelectedDate,
        setSelectedChildEvent,
        setShowCalendarInModal,
        selectChildEventAndContinue,
        setCheckoutOverlay,
        fetchEvent,
        setSelectedEventTimeObject,
    }, dispatch);
}

TicketsButtonContainer.propTypes = {
    showCheckoutCallback: PropTypes.func,
    title: PropTypes.string,
    type: PropTypes.string,
}

TicketsButtonContainer.defaultProps = {
    title: "",
    type: "",
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketsButtonContainer)
